import { StyleSheet } from "react-native";

export const helperStyles = StyleSheet.create({
    centerAlign: {
        justifyContent: 'center', 
        alignItems: 'center'
    }, 
    rowAlign: {
        flexDirection: 'row', 
        alignItems: 'center'
    },
    rowSpaceBetween: {
        flexDirection: 'row', 
        alignItems: 'center', 
        justifyContent: 'space-between'
    },
    columnSpaceBetween: {
        justifyContent: 'space-between', 
        alignItems: 'center'
    }
})

